import React from "react";
import PropTypes from "prop-types";
import HelperText from "../../../../../../../components/atoms/HelperText";

const PopulationFrequenciesHeaders = ({ nonpar, isMito, gnomadType }) => {
  return (
    <thead>
      <tr>
        <th className="tw-w-17/100">Population</th>
        <th className="tw-w-13/100" />
        <th className="tw-w-12/100 tw-text-right">
          Allele Count
          <HelperText fieldDescriptionKey="Allele Count" />
        </th>
        <th className="tw-w-13/100 tw-text-right">
          Allele Number
          <HelperText
            fieldDescriptionKey={`Gnomad${gnomadType}Allele Number`}
          />
        </th>
        {isMito && (
          <th className="tw-w-12/100 tw-text-right">
            Heteroplasmic
            <HelperText fieldDescriptionKey="Number of Heteroplasmic" />
          </th>
        )}
        <th className="tw-w-12/100 tw-text-right">
          {isMito ? "Homoplasmic" : "Homozygotes"}
          {isMito ? (
            <HelperText fieldDescriptionKey="Number of Homoplasmic" />
          ) : (
            <HelperText fieldDescriptionKey="Number of Homozygotes" />
          )}
        </th>
        {nonpar === 1 && (
          <th className="tw-w-12/100 tw-text-right">
            Hemizygotes
            <HelperText fieldDescriptionKey="Number of Hemizygotes" />
            <HelperText customText="The term describes an individual who has only one member of a chromosome pair or chromosome segment rather than the usual two. Hemizygosity is often used to describe X-linked genes in males who have only one X chromosome." />
          </th>
        )}
        <th className="tw-w-21/100 gnomad-af-td-padding">
          Allele Frequency
          <HelperText fieldDescriptionKey="Allele Frequency" />
        </th>
      </tr>
    </thead>
  );
};

PopulationFrequenciesHeaders.propTypes = {
  nonpar: PropTypes.number,
  isMito: PropTypes.bool,
  gnomadType: PropTypes.string,
};

PopulationFrequenciesHeaders.defaultProps = {
  nonpar: null,
  isMito: false,
  gnomadType: null,
};

export default PopulationFrequenciesHeaders;
